

const TransactionType = ({ amount, hraId, id }) => {
  let displayValue = '';
    
    if(id.includes('hraContribution')) displayValue = 'Allocation'
    else if(id.includes('hraReimbursemen')) displayValue = 'Reimbursements'
  return displayValue;
};

export default TransactionType;
